import * as React from "react";
import { useTranslation } from "react-i18next";
import { useThisHangar } from "../../hooks/useThisHangar";
import { HangarStack } from "./Hangar";
import { HangarPresenterBase, HANGAR_BACKGROUND_COLORS } from "./HangarPresenterBase";

// Re-export the background colors for backward compatibility
export { HANGAR_BACKGROUND_COLORS };

type Props = {
  id: string;
  stacks: HangarStack[];
  setStacks: (stacks: HangarStack[]) => void;
  isReference?: boolean;
  isAlgorithmTesting?: boolean;
};

/**
 * Wrapper component that uses useThisHangar hook and passes data to HangarPresenterBase
 * This maintains backward compatibility for existing usage
 */
export const HangarPresenter: React.FC<Props> = ({
  id,
  stacks,
  setStacks,
  isReference,
  isAlgorithmTesting = false,
}) => {
  const { t } = useTranslation();
  const { hangar, setHangar, history } = useThisHangar();

  if (!hangar) {
    return <div>{t('common.loading')}</div>;
  }

  return (
    <HangarPresenterBase
      id={id}
      stacks={stacks}
      setStacks={setStacks}
      isReference={isReference}
      isAlgorithmTesting={isAlgorithmTesting}
      hangar={hangar}
      setHangar={setHangar}
      history={history}
    />
  );
};